import { phoneFormatter } from 'merchant/services/Helper.service';

declare global {
  interface Window {
    smartech: any;
  }
}

const cartItems = (cart) => {
  let items = [];
  const host = `https://${window.location.hostname}`;
  cart.map((itm) => {
    items.push({
      id: itm.product_id,
      variantId: itm.variant_id,
      quantity: itm.quantity,
      item_price: itm.price / 100,
      title: itm.variant_title,
      category: itm.product_type,
      image: itm.image,
      url: `${host}${itm.url}`,
      sku: itm.sku,
    });
  });
  return items;
};

export const calledgeTag = (eventName, data) => {
  if (eventName === 'InitiateCheckout') {
    edgeTagCheckoutInitiate(data);
  } else if (eventName === 'AddShippingInfo') {
    edgeTagAddShipping(data);
  } else if (eventName === 'AddPaymentInfo') {
    edgeTagAddPaymentInfo(data);
  } else if (eventName === 'Purchase') {
    edgeTagPaymentCompleted(data);
  }
};

const edgeTagCheckoutInitiate = (data) => {
  let dataObj = {
    eventName: 'InitiateCheckout',
    data: {
      currency: data.commonAnalyticsData.currency,
      value: data.commonAnalyticsData.cart_after_discount,
      checkoutUrl: window.location.href,
      contents: cartItems(data.cart.items),
    },
  };
  edgeTagSendEvent(dataObj.eventName, dataObj.data);
};
const edgeTagAddShipping = (data) => {
  if (data?.analyticsPixelObj?.edgetag?.value === 'email') {
    //@ts-ignore
    edgetag('user', 'email', data.userAddress?.email?.toLowerCase());
  } else {
    //@ts-ignore
    edgetag('user', 'phone', phoneFormatter(data.phoneNumber, data.analyticsPixelObj?.edgetag));
  }
  let dataObj = {
    eventName: 'AddShippingInfo',
    data: {
      currency: data.commonAnalyticsData.currency,
      value: data.commonAnalyticsData.cart_after_discount,
      contents: cartItems(data.cart.items),
    },
    user: {
      email: data.userAddress.email,
      phone: `+91${data.userAddress.phone}`,
      firstName: data.userAddress.firstname,
      lastName: data.userAddress.lastname,
      city: data.userAddress?.city,
      state: data.userAddress?.state,
      zip: data.userAddress?.pincode,
      country: data.userAddress?.country,
    },
  };
  edgeTagSendEvent(dataObj.eventName, dataObj.data);
  //@ts-ignore
  edgetag('data', dataObj.user);
};

const edgeTagAddPaymentInfo = (data) => {
  let dataObj = {
    eventName: 'AddPaymentInfo',
    data: {
      currency: data.commonAnalyticsData.currency,
      value: data.commonAnalyticsData.cart_after_discount,
      contents: cartItems(data.cart.items),
    },
  };
  edgeTagSendEvent(dataObj.eventName, dataObj.data);
};

const edgeTagPaymentCompleted = (data) => {
  let dataObj = {
    eventName: 'Purchase',
    data: {
      currency: data.commonAnalyticsData.currency,
      value: data.commonAnalyticsData.cart_after_discount,
      contents: cartItems(data.cart.items),
      eventId: data.orderName,
      orderId: data.orderName,
    },
  };
  edgeTagSendEvent(dataObj.eventName, dataObj.data);
};

const edgeTagSendEvent = (event, data) => {
  //@ts-ignore
  edgetag('tag', event, data);
};
